import React from "react";
import { useNavigate } from "react-router-dom";
import { LayoutWithTopBar } from "../../../components/LayoutWithTopBar";
import { useTheme } from "../../../hooks/useTheme";
import { RestoreWalletForm } from "./components/RestoreWalletForm";

const RestoreWallet: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useTheme();

  const onClickPrevArrow = () => {
    if (isMobile) {
      return () => navigate("/home/wallet");
    }
    return undefined;
  };

  return (
    <LayoutWithTopBar
      breadcrumbs={[
        { title: "Wallet", onClick: () => navigate("/home/wallet") },
        { title: "Restore" },
      ]}
      onClickPrevArrow={onClickPrevArrow()}
      hideLineActiveCall
    >
      <div className="flex flex-col gap-6 p-4">
        <div className="text-base opacity-70 text-center">
          Enter your 12-word seed phrase to restore your wallet.
        </div>

        <RestoreWalletForm />
      </div>
    </LayoutWithTopBar>
  );
};

export default RestoreWallet;

